/* =========================================================================
   BoligRetning – Produkt-info som klikbare rækker + slide-in drawer
   (Sinnerup-inspireret. Erstatter de tidligere inline-faner.)

   VIGTIGT: beskrivelsen er variant-specifik (custom.tekstbeskrivelse). Temaet
   (Dawn) opdaterer .product__description's innerHTML ved hvert variantskift.
   Vi BEHOLDER derfor .product__description i DOM'en (skjult) og lytter med en
   MutationObserver, så rækker + drawer-indhold gen-parses for HVER variant.

   Regler:
   - Har beskrivelsen både <h4>Beskrivelse</h4> OG <h4>ProduktInfo</h4>:
       → Beskrivelse-række = indhold mellem; Produktinfo-række = indhold efter.
   - Ellers (ingen korrekt H4): INGEN Beskrivelse-række — alt i Produktinfo
       (løse <h4>-overskrifter strippes).
   - Variant-specifikt metafelt custom.produktinfo overskriver Produktinfo.
   - Levering og Retur er fast indhold.
   Styling ligger i assets/product-redesign.css.
   ========================================================================= */
(function () {
  'use strict';

  var LEVERING_HTML =
    '<p><strong>Leveringstid:</strong> 3-5 hverdage</p>' +
    '<p><strong>Fragt:</strong> 49 kr. – fri fragt på ordrer fra 799 kr. (efter rabat)</p>' +
    '<p><strong>Leveringspartner:</strong> GLS, PostNord eller DPD</p>' +
    '<p>Du får track &amp; trace på mail ved afsendelse, så du let kan følge din pakke på vej til dig.</p>' +
    '<p>Vi bestræber os på at levere alle produkter så hurtigt som muligt og altid i perfekt stand. Vi pakker omhyggeligt for at sikre, at dit nye produkt kommer sikkert frem til din dør.</p>' +
    '<p>Har du specielle ønsker til leveringen, er du velkommen til at kontakte vores kundeservice på <strong>info@boligretning.dk</strong>.</p>';

  var RETUR_HTML =
    '<p><strong>Fortrydelsesret:</strong> 14 dage fra modtagelse af varen</p>' +
    '<p><strong>Kontakt os:</strong> Skriv til <a href="mailto:info@boligretning.dk">info@boligretning.dk</a></p>' +
    '<p><strong>Proces:</strong> Skriv til os, så sender vi en returvejledning. Returfragten betaler du selv</p>' +
    '<p>Vi ønsker, at du skal være 100% tilfreds med dit køb. Derfor gør vi returprocessen så nem som muligt for dig.</p>' +
    '<p>Produktet skal returneres i original emballage eller tilsvarende forsvarlig indpakning. Har du spørgsmål til returprocessen, er du altid velkommen til at kontakte os.</p>' +
    '<p>Vi behandler din returanmodning og refunderer beløbet hurtigst muligt efter vi har modtaget varen retur.</p>';

  var TITLES = {
    beskrivelse: 'Beskrivelse',
    produktinfo: 'Produktinfo',
    levering: 'Levering og service',
    retur: 'Returnering'
  };

  var content = {
    beskrivelse: '',
    produktinfo: '',
    levering: LEVERING_HTML,
    retur: RETUR_HTML
  };

  var drawer = null;
  var drawerTitle = null;
  var drawerContent = null;
  var currentSection = null;
  var accordion = null;
  var descriptionEl = null;

  /* ---------- HTML mellem to overskrifter (robust mod <p>-indpakkede h4) ---------- */
  function rangeHtmlIn(container, startNode, endNode) {
    // Indhold EFTER startNode og FØR endNode inden for container. endNode=null → til containerens slutning.
    // Bruger en Range, så det virker uanset om <h4> er top-niveau eller pakket i <p>.
    var range = document.createRange();
    range.setStartAfter(startNode);
    if (endNode) {
      range.setEndBefore(endNode);
    } else {
      range.setEnd(container, container.childNodes.length);
    }
    var div = document.createElement('div');
    div.appendChild(range.cloneContents());
    return div.innerHTML;
  }
  // Den AKTUELLE variants beskrivelse: variant-metafelt custom.tekstbeskrivelse, ellers produktets basis-beskrivelse
  function getVariantDescription() {
    var id = getCurrentVariantId();
    if (id && window.variantMetafields && window.variantMetafields[id]) {
      var vt = window.variantMetafields[id]['custom.tekstbeskrivelse'];
      if (vt && vt.trim()) return vt;
    }
    if (typeof window.brProductDescription === 'string') return window.brProductDescription;
    return descriptionEl ? descriptionEl.innerHTML : '';
  }
  function stripH4(htmlString) {
    var tmp = document.createElement('div');
    tmp.innerHTML = htmlString;
    tmp.querySelectorAll('h4').forEach(function (h) { h.parentNode.removeChild(h); });
    return tmp.innerHTML;
  }

  /* ---------- Drawer ---------- */
  function buildDrawer() {
    // Draweren er normalt server-renderet i theme.liquid (snippet br-info-drawer).
    drawer = document.getElementById('br-info-drawer');
    if (!drawer) {
      // Fallback: opret den hvis snippet'en ikke er renderet.
      drawer = document.createElement('div');
      drawer.className = 'br-info-drawer';
      drawer.id = 'br-info-drawer';
      drawer.setAttribute('aria-hidden', 'true');
      drawer.innerHTML =
        '<div class="br-info-drawer__overlay" data-br-close></div>' +
        '<div class="br-info-drawer__inner" role="dialog" aria-modal="true" aria-labelledby="br-info-drawer-title">' +
          '<div class="br-info-drawer__header">' +
            '<h2 class="br-info-drawer__title" id="br-info-drawer-title"></h2>' +
            '<button class="br-info-drawer__close" type="button" data-br-close aria-label="Luk">&times;</button>' +
          '</div>' +
          '<div class="br-info-drawer__content" id="br-info-drawer-content"></div>' +
        '</div>';
      document.body.appendChild(drawer);
    }
    drawerTitle = drawer.querySelector('.br-info-drawer__title');
    drawerContent = drawer.querySelector('.br-info-drawer__content');

    // Luk-lyttere tilføjes uanset om draweren var server-renderet eller oprettet her
    drawer.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-br-close')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
    });
  }

  // Luk når man klikker udenfor selve drawer-panelet
  function handleOutsideClick(e) {
    if (drawer.classList.contains('active') && !e.target.closest('.br-info-drawer__inner')) {
      closeDrawer();
    }
  }

  function openDrawer(section) {
    if (!drawer) return;
    if (drawer.classList.contains('active') && currentSection === section) return;
    currentSection = section;
    drawerTitle.textContent = TITLES[section] || '';
    drawerContent.innerHTML = content[section] || '';
    drawerContent.scrollTop = 0;
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('br-drawer-open');
    // Tilføj på næste tick, så selve åbne-klikket ikke straks lukker draweren igen.
    setTimeout(function () {
      if (drawer.classList.contains('active')) document.addEventListener('click', handleOutsideClick);
    }, 0);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('br-drawer-open');
    document.removeEventListener('click', handleOutsideClick);
  }

  /* ---------- Rækker ---------- */
  function arrowSvg() {
    return '<svg class="br-info-row__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';
  }
  function makeRow(key) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'br-info-row';
    btn.setAttribute('data-br-section', key);
    btn.innerHTML = '<span>' + TITLES[key] + '</span>' + arrowSvg();
    btn.addEventListener('click', function () { openDrawer(key); });
    return btn;
  }

  function buildRows() {
    if (!accordion) return;
    var order = [];
    if (content.beskrivelse && content.beskrivelse.trim()) order.push('beskrivelse');
    if (content.produktinfo && content.produktinfo.trim()) order.push('produktinfo');
    order.push('levering', 'retur');

    var existing = accordion.querySelector('.br-info-rows');
    if (existing) existing.parentNode.removeChild(existing);

    var wrap = document.createElement('div');
    wrap.className = 'br-info-rows';
    order.forEach(function (key) { wrap.appendChild(makeRow(key)); });
    accordion.appendChild(wrap);
  }

  /* ---------- Variant-metafelt (custom.produktinfo) ---------- */
  function getCurrentVariantId() {
    var urlId = new URLSearchParams(window.location.search).get('variant');
    if (urlId) return urlId;
    var hidden = document.querySelector('input[name="id"][type="hidden"], input[name="id"][data-product-id]');
    if (hidden && hidden.value) return hidden.value;
    var checked = document.querySelector('input[name="id"]:checked, select[name="id"] option:checked');
    if (checked && checked.value) return checked.value;
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
      return String(window.ShopifyAnalytics.meta.selectedVariantId);
    }
    return null;
  }
  function getMetafieldFromPage(variantId) {
    if (!variantId) return null;
    if (window.variantMetafields && window.variantMetafields[variantId] &&
        window.variantMetafields[variantId]['custom.produktinfo']) {
      return window.variantMetafields[variantId]['custom.produktinfo'];
    }
    var el = document.querySelector(
      '[data-variant-metafield="' + variantId + '"][data-metafield-key="custom.produktinfo"]'
    );
    if (el && el.textContent.trim()) return el.textContent;
    return null;
  }

  /* ---------- Parse + genopbyg (kører ved load OG ved hvert variantskift) ---------- */
  function parseDescription() {
    // Parse den AKTUELLE variants beskrivelse i en løs holder — uafhængigt af om temaet
    // opdaterer den synlige DOM. querySelectorAll('h4') finder også h4 pakket i <p>.
    var holder = document.createElement('div');
    holder.innerHTML = getVariantDescription() || '';

    // Normalisér: hvis en <h4> er pakket i en <p> (evt. sammen med tekst), pak <p> ud,
    // så overskrifter altid er top-niveau-søskende og opdelingen bliver ren.
    Array.prototype.slice.call(holder.querySelectorAll('p')).forEach(function (p) {
      if (p.querySelector('h4')) {
        while (p.firstChild) p.parentNode.insertBefore(p.firstChild, p);
        p.parentNode.removeChild(p);
      }
    });

    var h4s = Array.prototype.slice.call(holder.querySelectorAll('h4'));

    var beskH4 = null, infoH4 = null;
    h4s.forEach(function (h) {
      var t = h.textContent.trim();
      if (!beskH4 && t.indexOf('Beskrivelse') !== -1) {
        beskH4 = h;
      } else if (!infoH4 && (t.indexOf('ProduktInfo') !== -1 || t.indexOf('Produkt Info') !== -1 || t.indexOf('Produktinfo') !== -1)) {
        infoH4 = h;
      }
    });

    // Begge overskrifter skal findes OG Beskrivelse skal stå før ProduktInfo
    var bothOrdered = beskH4 && infoH4 &&
      (beskH4.compareDocumentPosition(infoH4) & Node.DOCUMENT_POSITION_FOLLOWING);

    if (bothOrdered) {
      content.beskrivelse = rangeHtmlIn(holder, beskH4, infoH4);
      content.produktinfo = rangeHtmlIn(holder, infoH4, null);
    } else {
      // Ingen korrekt H4-struktur → INGEN Beskrivelse-række; alt i Produktinfo (uden løse h4)
      content.beskrivelse = '';
      content.produktinfo = stripH4(holder.innerHTML);
    }

    // Som den gamle customtabs: hvis varianten har sit EGET custom.produktinfo-metafelt,
    // vis den variant-specifikke info i Produktinfo OG skjul den generiske Beskrivelse
    // (den passer typisk ikke til den specifikke variant).
    var mf = getMetafieldFromPage(getCurrentVariantId());
    if (mf && mf.trim()) {
      content.produktinfo = mf;
      content.beskrivelse = '';
    }
  }

  function refreshOpenDrawer() {
    if (!drawer || !drawer.classList.contains('active')) return;
    var c = content[currentSection];
    if (c && c.trim && c.trim()) {
      drawerContent.innerHTML = c;
      drawerContent.scrollTop = 0;
    } else {
      // Den åbne sektion findes ikke længere for denne variant → luk
      closeDrawer();
    }
  }

  function rebuild() {
    parseDescription();
    buildRows();
    refreshOpenDrawer();
  }

  /* ---------- Init ---------- */
  function init() {
    descriptionEl = document.querySelector('.product__description');
    if (!descriptionEl) return;
    // Find den accordion der FAKTISK indeholder beskrivelsen (ikke en collapsible_tab-accordion)
    accordion = descriptionEl.closest('.product__accordion');
    if (!accordion) return;

    // Behold .product__description i DOM'en (skjult) så Dawn kan opdatere den
    // pr. variant — men skjul den oprindelige accordion-visning.
    var summary = accordion.querySelector('.accordion-summary');
    if (summary) summary.style.display = 'none';
    var accContent = accordion.querySelector('.accordion-content');
    if (accContent) accContent.style.display = 'none';

    buildDrawer();
    rebuild();

    // Deterministisk: gen-parse ved hvert variantskift (læser variantens egen beskrivelse)
    var vs = document.querySelector('variant-selects');
    if (vs) {
      vs.addEventListener('change', function () { setTimeout(rebuild, 0); });
    }
    // Backup: hvis temaet selv ændrer beskrivelsen i DOM'en, fang det også
    var target = accContent || descriptionEl;
    if (target) {
      var observer = new MutationObserver(function () { rebuild(); });
      observer.observe(target, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
